module.exports = __webpack_public_path__ + "img/36-r.d0116abe.png";